import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = ['tabButton', 'citationText', 'copyButton']

  initialize() {
    this.initializeTabSwitching();
    this.initializeSearchField();
    this.onMainTabShown = this.onMainTabShown.bind(this);
  }

  connect() {
    this.showFirstTableByDefault();
    this.setupMainTabActivation();
  }

  // Search Field Dynamic Font Styling
  initializeSearchField() {
    const searchField = document.querySelector('.search-input-field');
    if (searchField) {
      searchField.addEventListener('input', this.handleSearchFieldInput.bind(this));
      // Set initial font based on existing value
      this.updateSearchFieldFont(searchField);
    }
  }

  handleSearchFieldInput(event) {
    this.updateSearchFieldFont(event.target);
  }

  updateSearchFieldFont(field) {
    const text = field.value.trim();
    
    // Remove existing classes
    field.classList.remove('search-field-ottoman', 'search-field-latin');
    
    // Only apply styling if field has content
    if (text.length > 0) {
      const isOttomanText = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/.test(text);
      
      if (isOttomanText) {
        // Add Ottoman styling class
        field.classList.add('search-field-ottoman');
      } else {
        // Add Latin styling class
        field.classList.add('search-field-latin');
      }
    }
  }

  // Tab Switching Functionality
  initializeTabSwitching() {
    this.handleTabSwitching = this.handleTabSwitching.bind(this);
  }

  handleTabSwitching(event) {
    event.preventDefault();

    const clickedButton = event.currentTarget;
    const container = clickedButton.closest('.results-container') || document;

    // Remove active class from all buttons within the same pane
    const allTabButtons = container.querySelectorAll('.js-search-results-tab-btn');
    allTabButtons.forEach(button => {
      button.classList.remove('active', 'btn-outline-primary');
      button.classList.add('btn-outline-secondary');
    });

    // Add active class to clicked button
    clickedButton.classList.remove('btn-outline-secondary');
    clickedButton.classList.add('active', 'btn-outline-primary');

    // Get the corresponding table ID
    const tableId = clickedButton.getAttribute('href');

    // Hide all tables within the same pane
    container.querySelectorAll('.js-search-results-table').forEach(table => {
      table.classList.add('d-none');
    });

    // Show the selected table
    const targetTable = container.querySelector(tableId);
    if (targetTable) {
      targetTable.classList.remove('d-none');
    }
  }

  setupMainTabActivation() {
    // Bootstrap tab "shown" event to reveal the pane's main table
    document.querySelectorAll('#searchResultsTabs button[data-bs-toggle="tab"]').forEach(btn => {
      btn.addEventListener('shown.bs.tab', this.onMainTabShown);
    });
  }

  onMainTabShown(e) {
    const targetSelector = e.target.getAttribute('data-bs-target'); // e.g., "#main-results" or "#sounds-like"
    const pane = document.querySelector(targetSelector);
    if (!pane) return;

    const container = pane.querySelector('.results-container');
    if (!container) return;

    // Hide all tables in this pane
    container.querySelectorAll('.js-search-results-table').forEach(table => {
      table.classList.add('d-none');
    });

    // Show the pane's main table (id ends with "-main")
    const mainTable = container.querySelector('.js-search-results-table[id$="-main"]');
    if (mainTable) {
      mainTable.classList.remove('d-none');
    }

    // Reset mini-tab buttons state within this pane
    const buttons = container.querySelectorAll('.js-search-results-tab-btn');
    buttons.forEach(btn => {
      btn.classList.remove('active', 'btn-outline-primary');
      btn.classList.add('btn-outline-secondary');
    });

    // Activate the mini-tab button that points to the main table
    if (mainTable) {
      const mainBtn = Array.from(buttons).find(b => b.getAttribute('href') === `#${mainTable.id}`);
      if (mainBtn) {
        mainBtn.classList.remove('btn-outline-secondary');
        mainBtn.classList.add('active', 'btn-outline-primary');
      }
    }
  }

  showFirstTableByDefault() {
    // For each pane, ensure its main table is visible initially
    document.querySelectorAll('.results-container').forEach(container => {
      const mainTable = container.querySelector('.js-search-results-table[id$="-main"]');
      if (mainTable) {
        mainTable.classList.remove('d-none');
      }
    });
  }

  // Citation Copy Functionality
  copyCitation(event) {
    const copyButton = event.currentTarget;
    const citationContainer = copyButton.closest('.js-citation-format');
    const citationText = citationContainer.querySelector('.js-citation-text');

    if (!citationText) return;

    const textToCopy = citationText.textContent.trim();

    // Copy to clipboard using standard pattern
    this.copyToClipboard(textToCopy);
    this.showCopySuccess(copyButton);
  }

  copyToClipboard(content) {
    navigator.clipboard.writeText(content);
  }

  showCopySuccess(copyButton) {
    const originalText = copyButton.innerHTML;

    copyButton.innerHTML = '<i data-feather="check" style="width: 14px; height: 14px;"></i> Copied!';
    copyButton.classList.add('btn-success');
    copyButton.classList.remove('btn-outline-primary');
  }

  // Action methods for events from HTML
  switchTab(event) {
    this.handleTabSwitching(event);
  }
}